import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './InternationalSection.css';
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const InternationalSection = ({ schoolData }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  const images = [
    { src: `${baseAPIUrl}assets/images/international-relations/pic_1.jpg`, alt: 'International collaboration' },
    { src: `${baseAPIUrl}assets/images/international-relations/pic_2.jpg`, alt: 'Student exchange program' },
    { src: `${baseAPIUrl}assets/images/international-relations/pic_3.jpg`, alt: 'Global education' },
    { src: `${baseAPIUrl}assets/images/international-relations/pic_4.jpg`, alt: 'International collaboration' },
    { src: `${baseAPIUrl}assets/images/international-relations/pic_5.jpg`, alt: 'Student exchange program' }
  ];

  const settings = isMobile ? {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    arrows: true,
    centerMode: false,
    variableWidth: false
  } : {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: isVisible,
    autoplaySpeed: 2800,
    cssEase: 'linear',
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <section ref={sectionRef} className="international-section">
      <div className="international-container">
        <h2 className="international-title">INTERNATIONAL RELATIONS</h2>
        <p className="international-text">
          At Techno India Group Public School (TIGPS), we believe in nurturing global citizens who are not only academically strong but also possess a deep understanding of different cultures and perspectives. Our vibrant International Relations programme fosters a spirit of collaboration and exchange.  We are thrilled to announce that a student from TIGPS Bolpur has been selected to participate in the prestigious Salam International Youth Film Festival in Azerbaijan!  TIGPS made us proud by securing a top position at the National Level Spell-Bee Competition. TIGPS Hooghly has initiated an exchange programme, "TIGPS Hooghly-China Friendship," allowing students to engage in cultural exchange activities and learn from each other's traditions.  These are just a few examples of our ongoing international endeavors. We are constantly seeking new partnerships and opportunities to broaden the horizons of our students.
        </p>
        
        <Slider {...settings} className="international-slider">
          {images.map((image, index) => (
            <div key={index} className="international-slide">
              <div className="international-image">
                <img src={image.src} alt={image.alt} />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default InternationalSection;
